import React from "react";

interface Props {
  value: string
}

const ReadonlyEmail = ({ value }: Props) => {
  return <a href={"mailto:" + value}>
    {value}
  </a>;
};

export default ReadonlyEmail;